import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import { Eye, EyeOff } from "lucide-react"; // Icônes pour afficher/masquer
import { Editor } from "@tinymce/tinymce-react";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Tooltip,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { FiChevronUp, FiChevronDown, FiEdit3 } from "react-icons/fi";
import { makeSelectStyles } from "../../common/selectStyles";
function NewMessage() {
  const editorRef = useRef(null);

  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  //meta title
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [messageContent, setMessageContent] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  // Variable
  const [formData, setFormData] = useState({
    "Nom de l'action": "",
    Sujet: "",
    Actif: {
      label: "Oui",
      value: 1,
    },
    "Balises non nulles": "",

    Message: "",
    "Pièce jointe": {
      label: "Non",
      value: 0,
    },
    "CGP en copie": {
      label: "Non",
      value: 0,
    },
    Publipostage: {
      label: null,
      value: null,
    },
    "Statut de réservation": {
      label: null,
      value: null,
    },
    "Mode de règlement": {
      label: null,
      value: null,
    },
    "Statut de signature": {
      label: null,
      value: null,
    },
    "Compte de messagerie": {
      label: null,
      value: null,
    },
  });

  // Fonction pour gérer les changements de valeurs
  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  /*************************   Publipostages  *******************************/
  const [Publipostage, setPublipostageData] = useState({ data: [] });

  const getPublipostage = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/publipostages`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((Publipostage) => {
          setPublipostageData(Publipostage);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPublipostageOptions = () => {
    return [
      {
        options: Publipostage.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   StatutsReservations  *******************************/
  const [StatutsReservations, setStatutsReservationsData] = useState({
    data: [],
  });

  const getStatutsReservations = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/statuts_reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((StatutsReservations) => {
          setStatutsReservationsData(StatutsReservations);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutsReservationsOptions = () => {
    return [
      {
        options: StatutsReservations.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   ModeReglement  *******************************/
  const [ModeReglement, setModeReglementData] = useState({ data: [] });

  const getModeReglement = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/mode_reglements`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((ModeReglement) => {
          setModeReglementData(ModeReglement);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeReglementOptions = () => {
    return [
      {
        options: ModeReglement.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   SmtpParametres  *******************************/
  const [SmtpParametres, setSmtpParametresData] = useState({ data: [] });

  const getSmtpParametres = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/smtp_parametres`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((SmtpParametres) => {
          setSmtpParametresData(SmtpParametres);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSmtpParametresOptions = () => {
    return [
      {
        options: SmtpParametres.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   StatutsSignature  *******************************/
  const [StatutsSignature, setStatutsSignatureData] = useState({ data: [] });

  const getStatutsSignature = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/messages/statuts_signatures`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((StatutsSignature) => {
          setStatutsSignatureData(StatutsSignature);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutsSignatureOptions = () => {
    return [
      {
        options: StatutsSignature.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  ///
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  ///
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(`https://www.fluxod.com/${api}/messages/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          nom_action: formData["Nom de l'action"],
          sujet: formData.Sujet,
          message: messageContent,
          pj: formData["Pièce jointe"]?.value == 1 ? 1 : 2,
          cgp_copie: formData["CGP en copie"]?.value == 1 ? 1 : 2,
          publipostage_id:
            formData["Pièce jointe"]?.value == 1
              ? formData.Publipostage?.value
              : null,
          actif: formData["Actif"]?.value || "",
          smtp_parametre_id: formData["Compte de messagerie"]?.value || "",
          statuts_reservation_id:
            formData["Statut de réservation"]?.value || "",
          mode_reglement_id: formData["Mode de règlement"]?.value || "",
          statuts_signature: formData["Statut de signature"]?.value || "",
          balises_non_nulles: formData["Balises non nulles"],
        }),
      });

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.message_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.message_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/
  const [listeData, setListeData] = useState("");

  const getListe = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/messages/list_tags?publipostage_id=${
          formData.Publipostage?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setListeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPublipostage();
    getStatutsReservations();
    getModeReglement();
    getSmtpParametres();
    getStatutsSignature();
  }, []);
  useEffect(() => {
    getListe();
  }, [formData.Publipostage]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Messages | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Message
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Offcanvas
              isOpen={showOffcanvas}
              scrollable
              backdrop={false}
              toggle={handleOffcanvasToggle}
              style={{ width: "35%" }}
            >
              <OffcanvasHeader toggle={handleOffcanvasToggle}>
                Liste des balises
              </OffcanvasHeader>
              <OffcanvasBody>
                <div dangerouslySetInnerHTML={{ __html: listeData.message }} />
              </OffcanvasBody>
            </Offcanvas>
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/messages/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Messages
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          configData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="12">
                                <Col>
                                  {formData ? (
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleIdentificationAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Identification
                                          </span>
                                        </div>
                                        {isIdentificationAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isIdentificationAccordionOpen}
                                      >
                                        <CardBody className="p-3">
                                          {/* Liste des balises disponibles */}
                                          <div
                                            className="mb-3 px-2 py-2"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              borderLeft: "3px solid #007bff",
                                            }}
                                          >
                                            <Row className="align-items-center">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Liste des balises
                                                    disponibles
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Button
                                                  color="primary"
                                                  size="sm"
                                                  onClick={
                                                    handleOffcanvasToggle
                                                  }
                                                  className="shadow-sm"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                  }}
                                                >
                                                  <i className="bx bx-list-ul me-1"></i>
                                                  Liste
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Champs dynamiques */}
                                          <div className="fields-container">
                                            {Object.keys(formData).map(
                                              (key) => {
                                                // Condition pour masquer Publipostage si Pièce jointe !== 1
                                                if (
                                                  key === "Publipostage" &&
                                                  formData["Pièce jointe"]
                                                    ?.value !== 1
                                                ) {
                                                  return null;
                                                }

                                                const isMessage =
                                                  key === "Message";
                                                const isSelect = [
                                                  "Publipostage",
                                                  "Statut de réservation",
                                                  "Mode de règlement",
                                                  "Statut de signature",
                                                  "Compte de messagerie",
                                                ].includes(key);
                                                const isSwitch =
                                                  typeof formData[key] ===
                                                    "object" &&
                                                  key !== "Publipostage";
                                                const isTextarea =
                                                  key === "Balises non nulles";
                                                const hasTooltip =
                                                  key === "Balises non nulles";

                                                // Si c'est le champ Message (TinyMCE), traitement spécial
                                                if (isMessage) {
                                                  return (
                                                    <div
                                                      key={key}
                                                      className="mb-3"
                                                      style={{
                                                        borderRadius: "8px",
                                                        overflow: "hidden",
                                                      }}
                                                    >
                                                      <label
                                                        className="form-label fw-medium small text-muted mb-2"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                        }}
                                                      >
                                                        {key} :
                                                      </label>
                                                      <Editor
                                                        onEditorChange={(
                                                          content
                                                        ) => {
                                                          setMessageContent(
                                                            content
                                                          );
                                                        }}
                                                        apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                                        onInit={(evt, editor) =>
                                                          (editorRef.current =
                                                            editor)
                                                        }
                                                        initialValue={
                                                          formData["Message"]
                                                        }
                                                        init={{
                                                          height: 500,
                                                          menubar: true,
                                                          plugins: [
                                                            "advlist",
                                                            "autolink",
                                                            "lists",
                                                            "link",
                                                            "image",
                                                            "charmap",
                                                            "preview",
                                                            "anchor",
                                                            "searchreplace",
                                                            "visualblocks",
                                                            "code",
                                                            "fullscreen",
                                                            "insertdatetime",
                                                            "media",
                                                            "table",
                                                            "help",
                                                            "wordcount",
                                                            "autosave",
                                                          ],
                                                          toolbar:
                                                            "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
                                                          content_style:
                                                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                        }}
                                                      />
                                                    </div>
                                                  );
                                                }

                                                // Tous les autres champs
                                                return (
                                                  <div
                                                    key={key}
                                                    className="field-item px-2 py-1 mb-1"
                                                    style={{
                                                      backgroundColor: "white",
                                                      transition:
                                                        "all 0.15s ease",
                                                      borderLeft:
                                                        "3px solid transparent",

                                                      position: "relative",
                                                      marginBottom: "1px",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#e3f2fd";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "#007bff";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "white";
                                                      e.currentTarget.style.borderLeftColor =
                                                        "transparent";
                                                    }}
                                                  >
                                                    <Row className="align-items-center g-1">
                                                      <Col xs={12} md={4}>
                                                        <div className="d-flex align-items-center small text-muted">
                                                          <span
                                                            className="fw-medium"
                                                            style={{
                                                              fontSize:
                                                                "0.8rem",
                                                              letterSpacing:
                                                                "0.2px",
                                                            }}
                                                          >
                                                            {key}
                                                          </span>
                                                          {hasTooltip && (
                                                            <>
                                                              <i
                                                                className="bx bx-info-circle ms-1"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  color:
                                                                    "#007bff",
                                                                  fontSize:
                                                                    "14px",
                                                                }}
                                                                id="balisenonnulles"
                                                                onMouseEnter={
                                                                  toggleTooltip
                                                                }
                                                                onMouseLeave={
                                                                  toggleTooltip
                                                                }
                                                              />
                                                              <Tooltip
                                                                placement="top"
                                                                isOpen={
                                                                  tooltipOpen
                                                                }
                                                                target="balisenonnulles"
                                                                toggle={
                                                                  toggleTooltip
                                                                }
                                                              >
                                                                Saisir ici les
                                                                balises séparées
                                                                par des virgules
                                                                qui, si elles
                                                                sont vides, ne
                                                                déclencheront
                                                                pas l'envoi du
                                                                message.
                                                              </Tooltip>
                                                            </>
                                                          )}
                                                          <span className="ms-1 text-primary">
                                                            :
                                                          </span>
                                                        </div>
                                                      </Col>
                                                      <Col xs={12} md={8}>
                                                        {isSelect ? (
                                                          <Select
                                                            value={
                                                              formData[key]
                                                            }
                                                            onChange={(e) =>
                                                              handleInputChange(
                                                                key,
                                                                e
                                                              )
                                                            }
                                                            options={
                                                              key ===
                                                              "Publipostage"
                                                                ? renderPublipostageOptions()
                                                                : key ===
                                                                  "Statut de réservation"
                                                                ? renderStatutsReservationsOptions()
                                                                : key ===
                                                                  "Mode de règlement"
                                                                ? renderModeReglementOptions()
                                                                : key ===
                                                                  "Statut de signature"
                                                                ? renderStatutsSignatureOptions()
                                                                : renderSmtpParametresOptions()
                                                            }
                                                            isClearable={true}
                                                            classNamePrefix="select2-selection"
                                                            styles={styles(
                                                              false
                                                            )}
                                                            menuPortalTarget={
                                                              document.body
                                                            }
                                                          />
                                                        ) : isSwitch ? (
                                                          <div className="d-flex align-items-center">
                                                            <Switch
                                                              uncheckedIcon={
                                                                <Offsymbol />
                                                              }
                                                              checkedIcon={
                                                                <OnSymbol />
                                                              }
                                                              onColor="#555B21"
                                                              onChange={() => {
                                                                handleInputChange(
                                                                  key,
                                                                  {
                                                                    label:
                                                                      formData[
                                                                        key
                                                                      ]
                                                                        .value ===
                                                                      1
                                                                        ? "Non"
                                                                        : "Oui",
                                                                    value:
                                                                      formData[
                                                                        key
                                                                      ]
                                                                        .value ===
                                                                      1
                                                                        ? 2
                                                                        : 1,
                                                                  }
                                                                );
                                                              }}
                                                              checked={
                                                                formData[key]
                                                                  ?.value === 1
                                                              }
                                                              height={24}
                                                              width={48}
                                                              handleDiameter={
                                                                20
                                                              }
                                                            />
                                                            <span
                                                              className="ms-2 small text-muted"
                                                              style={{
                                                                fontSize:
                                                                  "0.75rem",
                                                              }}
                                                            ></span>
                                                          </div>
                                                        ) : isTextarea ? (
                                                          <div
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <textarea
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                formData[key]
                                                              }
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  key,
                                                                  e.target.value
                                                                )
                                                              }
                                                              rows={3}
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                resize:
                                                                  "vertical",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "8px",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <div
                                                            style={{
                                                              position:
                                                                "relative",
                                                            }}
                                                          >
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                formData[key]
                                                              }
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  key,
                                                                  e.target.value
                                                                )
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            <FiEdit3
                                                              size={12}
                                                              className="position-absolute text-muted"
                                                              style={{
                                                                right: "8px",
                                                                top: "50%",
                                                                transform:
                                                                  "translateY(-50%)",
                                                                pointerEvents:
                                                                  "none",
                                                                opacity: 0.9,
                                                              }}
                                                            />
                                                          </div>
                                                        )}
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  ) : null}
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewMessage;
